import { useRef, useState } from 'react';

// `list` with its item at `from` moved to `to`.
export const moveItem = (list, from, to) => {
  const next = [...list];
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next;
};

/**
 * A list reordered by dragging its rows (the browser's drag and drop), as the
 * columns' modal does: `onMove(from, to)` each time the dragged row passes
 * over another. `rowProps(index)` goes on each row that may be dragged;
 * `draggingIndex` is where the dragged row stands, null between drags.
 */
const useDragReorder = (onMove) => {
  const dragging = useRef(null);
  const [draggingIndex, setDraggingIndex] = useState(null);
  const rowProps = (index) => ({
    draggable: true,
    onDragStart: () => {
      dragging.current = index;
      setDraggingIndex(index);
    },
    onDragOver: (event) => {
      event.preventDefault();
      if (dragging.current === null || dragging.current === index) return;
      onMove(dragging.current, index);
      dragging.current = index;
      setDraggingIndex(index);
    },
    onDragEnd: () => {
      dragging.current = null;
      setDraggingIndex(null);
    },
  });
  return { rowProps, draggingIndex };
};

export default useDragReorder;
